// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import './config/rem'

import * as mobile from './config/mUtils'

import store from './story/'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import * as getData from './service/getData'
import components from './components/'

Object.keys(components).forEach((key) => {
  var name = key.replace(/(\w)/, (v) => v.toUpperCase()) // 首字母大写
  Vue.component(`v${name}`, components[key])
})
Vue.use(VueAwesomeSwiper)


router.afterEach((to, from, next) => { // 路由切换结束的钩子方法

})

Vue.prototype.golook = (list) => {
  if (list.length) {
    mobile.setStore('pics', list)
    router.push('/lookPicture')
  }
}
Vue.prototype.golookTxt = (info) => {
  if (info && info.textInfo) {
    mobile.setStore('textInfo', info)
    router.push('/picture')
  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js